import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { resolveResponsivePropSafe } from '../../../library/props/responsiveProp';
import { resolveResponsiveRangePropsOptional } from '../../../library/props/responsiveRangeProps';
import { Box } from '../Box/Box';
import { FlexViewContext } from './FlexViewContext';
import * as styles from './Item.css';
export const Item = _a => {
  var _b;

  var {
    children,
    width,
    minWidth,
    maxWidth,
    hide,
    className
  } = _a,
      allBoxProps = __rest(_a, ["children", "width", "minWidth", "maxWidth", "hide", "className"]);

  const {
    space,
    spaceX,
    spaceY,
    alignItems,
    justifyContent,
    componentItem
  } = useContext(FlexViewContext);
  const display = pipe(O.fromNullable(alignItems || justifyContent), O.fold(() => 'block', () => 'flex'));
  return _jsx(Box, Object.assign({
    minWidth: 0,
    paddingLeft: spaceX || space,
    paddingTop: spaceY || space,
    className: [resolveResponsivePropSafe(width, styles.width), resolveResponsivePropSafe(minWidth, styles.minWidth), resolveResponsivePropSafe(maxWidth, styles.maxWidth), className],
    display: (_b = resolveResponsiveRangePropsOptional(hide, 'none', display)) !== null && _b !== void 0 ? _b : display,
    justifyContent: justifyContent,
    alignItems: alignItems,
    component: componentItem
  }, allBoxProps, {
    children: children
  }));
};
//# sourceMappingURL=Item.js.map